import { Card } from '@/components/ui/card';
import { getS3Url } from '@/config/s3.config';
import { Category } from '@repo/types/src/glow-up';
import { DeleteCategory } from './DeleteCategory';
import { EditCategory } from './EditCategory';

type CategoryCardProps = {
  category: Category;
  refetch: () => void;
};

export const CategoryCard = ({ category, refetch }: CategoryCardProps) => {
  return (
    <Card className="p-4 w-80 flex flex-col gap-4">
      <div className="aspect-square overflow-hidden rounded-lg">
        <img
          src={getS3Url(category.image)}
          alt={category.title}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="font-semibold text-lg">{category.title}</h3>
        <p className="text-sm text-gray-600 line-clamp-2">
          {category.description}
        </p>
        <p className="text-xs text-gray-500">Thème ID: {category.themeId}</p>
      </div>

      <div className="flex gap-2 mt-auto">
        <EditCategory category={category} refetch={refetch} />
        <DeleteCategory category={category} refetch={refetch} />
      </div>
    </Card>
  );
};
